import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class ScrollToTop extends BaseComponent {
	properties() {
		return {
			duration: 1000,
			preventDefault: true,
		};
	}

	connected() {
		this.element.removeAttribute('cloak');
		this._lastScrollY = 0;
		this._calculateScrollPosition = true;
	}

	events() {
		return {
			this: {
				click: (e) => {
					if (this.preventDefault) e.preventDefault();
					this.scrollToTop();
				},
			},
			window: {
				scroll: () => {
					if (!this._calculateScrollPosition) {
						// don't toggle the button
						return;
					}

					const { scrollY } = window;

					this.toggleVisibility(scrollY);

					this._calculateScrollPosition = false;
					this._lastScrollY = scrollY;

					requestAnimationFrame(() => (this._calculateScrollPosition = true));
				},
			},
		};
	}

	shouldShow(currentScrollY) {
		if (window.innerHeight + currentScrollY >= document.body.offsetHeight) {
			// bottom of page.
			return true;
		}

		if (scrollY > this._lastScrollY) {
			// scrolling down.
			return false;
		}

		// the user has left the initial viewport.
		return currentScrollY > window.innerHeight;
	}

	toggleVisibility(currentScrollY) {
		const shouldShow = this.shouldShow(currentScrollY);
		this.element.classList.toggle('show', shouldShow);
	}

	scrollToTop() {
		const htmlScroll = window
			.getComputedStyle(document.querySelectorAll('html')[0], null)
			.getPropertyValue('scroll-behavior');

		if (htmlScroll === 'smooth') {
			window.scrollTo(0, 0);
		} else {
			const duration = this.duration;
			const difference = document.documentElement.scrollTop || document.body.scrollTop;
			const startTime = performance.now();

			function step(timeStamp) {
				let normalizedTime = (timeStamp - startTime) / duration;
				if (normalizedTime > 1) normalizedTime = 1;

				window.scrollTo(0, difference * Math.cos(normalizedTime * Math.PI));
				if (normalizedTime < 1) window.requestAnimationFrame(step);
			}
			window.requestAnimationFrame(step);
		}
	}
}

defineComponent('scroll-to-top', ScrollToTop);
